import "./bootstrap/index.js";
import "./layout-builder/layouts-loader.js";
import "./components/index.js";
import "./navigation.js";
import "./sticky-header-bar.js";
import "./article.js";
import "./loader.js";
import "./share.js";
import "./article-listings.js";
import "./lazy-load-refresh.js";
import "./remove-sibling-hairlines.js";

import ScrollTrigger from "gsap/ScrollTrigger";
import ScrollSmoother from "gsap/ScrollSmoother";
import gsap from "gsap";

gsap.registerPlugin(ScrollTrigger, ScrollSmoother);

let scroller;

function markFirstAndSecondFullscreenPosts() {
  if (document.body.classList.contains("home")) {
    const posts = document.querySelectorAll(".layout--fullscreen-post");
    if (posts.length > 0) {
      posts[0].classList.add("is-first");
    }
    if (posts.length > 1) {
      posts[1].classList.add("is-second");
    }
  }
}

document.addEventListener("DOMContentLoaded", markFirstAndSecondFullscreenPosts);
document.addEventListener("DOMContentLoaded", () => scroller = ScrollSmoother.create({ smooth: 1, effects: true, smoothTouch: 0.1 }));

//document.addEventListener("scroll.pause", () => scroller.paused(true));
